(() => {
  if (window.plenicalmProductBound) return;
  window.plenicalmProductBound = true;
  const root = document.querySelector('product-info');
  if (!root || !document.querySelector('.pc-summary')) return;
  const variants = JSON.parse(document.querySelector('[data-pc-variants]').textContent);
  const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const nativeButton = () => root.querySelector('.product-form__submit');
  const quantity = () => root.querySelector('input[name="quantity"]');
  let desiredQuantity = Number(quantity()?.value || 1);
  const selected = () => variants.find(v => String(v.id) === root.querySelector('form input[name="id"]')?.value) || variants[0];
  const packCents = (price, n, d, fixed) => fixed ? fixed : d ? Math.floor(price * n * (100 - d) / 1000) * 10 : price * n;
  const cardCents = (v, card, n) => packCents(v.price, n, Number(card?.dataset.pcDiscount || 0), Number(card?.dataset.pcPack || 0));
  const mediaOrder = (document.querySelector('[data-pc-media]')?.dataset.pcMedia || '').split(',').filter(Boolean);
  const gallery = root.querySelector('[id^="Slider-Gallery-"]');
  if (gallery && mediaOrder.length) {
    const slides = mediaOrder.map(id => gallery.querySelector(':scope > [data-media-id$="-' + id + '"]')).filter(Boolean);
    if (slides[0] && gallery.firstElementChild !== slides[0]) {
      gallery.querySelectorAll(':scope > .is-active').forEach(el => el.classList.remove('is-active'));
      slides.forEach(el => gallery.appendChild(el));
      slides[0].classList.add('is-active');
    }
  }
  const setText = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
  const sync = () => {
    const v = selected();
    const input = quantity();
    if (input && Number(input.value) !== desiredQuantity) input.value = String(desiredQuantity);
    const q = desiredQuantity;
    document.querySelectorAll('[data-pc-count]').forEach(card => {
      const n = Number(card.dataset.pcCount);
      const d = Number(card.dataset.pcDiscount || 0) || Number(card.dataset.pcPack || 0);
      card.setAttribute('aria-pressed', String(n === q));
      setText(card.querySelector('[data-pc-total]'), money.format(cardCents(v, card, n) / 100));
      const was = card.querySelector('[data-pc-was]');
      if (was) setText(was, d ? money.format(v.price * n / 100) : '');
    });
    const btn = nativeButton();
    if (btn && !btn.disabled) setText(btn.querySelector('span'), document.querySelector('[data-pc-label]').dataset.pcLabel);
    const sticky = document.querySelector('[data-pc-sticky]');
    if (sticky && btn) {
      const rect = btn.getBoundingClientRect();
      sticky.hidden = rect.bottom >= 0;
      const copy = sticky.querySelector('button');
      if (copy.disabled !== btn.disabled) copy.disabled = btn.disabled;
      setText(copy, btn.disabled ? 'Actuellement indisponible' : 'Ajouter au panier — ' + money.format(cardCents(v, document.querySelector('[data-pc-count="' + q + '"]'), q) / 100));
      setText(sticky.querySelector('[data-pc-choice]'), v.title + ' · ' + q + (q === 1 ? ' bandeau' : ' bandeaux'));
    }
  };
  document.addEventListener('click', e => {
    const card = e.target.closest('[data-pc-count]');
    if (card) {
      desiredQuantity = Number(card.dataset.pcCount);
      const input = quantity();
      if (input) { input.value = card.dataset.pcCount; input.dispatchEvent(new Event('change', { bubbles: true })); }
      sync();
    }
    if (e.target.closest('[data-pc-sticky] button')) nativeButton()?.click();
    if (e.target.closest('[data-pc-buy]')) { const b = nativeButton(); if (b && !b.disabled) b.click(); else document.getElementById('plenicalm-top')?.scrollIntoView({ behavior: 'smooth' }); }
  });
  document.addEventListener('change', e => {
    if (e.target.matches('input[name="quantity"]')) desiredQuantity = Number(e.target.value || 1);
    sync();
  });
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync, { passive: true });
  new MutationObserver(sync).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'value'] });
  document.querySelectorAll('video[data-pc-video]').forEach(video => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); video.removeAttribute('autoplay'); }
  });
  sync();
})();

